import { createStyles } from "@mui/styles";
import { palette } from "../../../styles/theme";
import { Box, BoxProps } from "./Box";
const PaddingX = "20px";
const PaddingY = "12px";

const hoverBackground = (
  liteBorder: boolean
) => `linear-gradient(90deg, rgba(36, 132, 186, 0.04) 0%, rgba(169, 84, 222, 0.04) 100%),
    ${liteBorder ? palette.lightBorderGradient : palette.borderGradient}`;

const gradientContainerStyles = (
  liteBorder: boolean,
  borderWidth: string,
  forceGradient: boolean,
  borderWidthWhenActive: string,
  active: boolean
) => ({
  background: forceGradient
    ? hoverBackground
    : liteBorder
      ? palette.lightBorderGradient
      : palette.borderGradient,
  border: `${active ? borderWidthWhenActive : borderWidth} solid transparent`,
  ":hover": {
    background: hoverBackground(liteBorder),
    border: `${active ? borderWidthWhenActive : borderWidth} solid transparent`,
  },
});

const useStyles = (
  liteBorder: boolean,
  borderWidth: string,
  forceGradient: boolean,
  borderWidthWhenActive: string,
  active: boolean
) =>
  createStyles({
    container: {
      borderRadius: "12px",
      cursor: "pointer",
      border: `${borderWidth} solid ${palette.grey.darkGrey}`,
      px: `calc(${PaddingX} - ${borderWidth})`,
      py: `calc(${PaddingY} - ${borderWidth})`,
      "&:hover:not(:active)": active
        ? gradientContainerStyles(
            liteBorder,
            borderWidth,
            forceGradient,
            borderWidthWhenActive,
            active
          )
        : {
            background: `linear-gradient(90deg, rgba(36, 132, 186, 0.04) 0%, rgba(169, 84, 222, 0.04) 100%),
          ${liteBorder ? palette.lightBorderGradient : palette.borderGradientHover}`,
            border: `${borderWidth} solid transparent`,
          },
      "&:active": gradientContainerStyles(
        liteBorder,
        borderWidth,
        forceGradient,
        borderWidthWhenActive,
        active
      ),
    },
    gradientContainer: gradientContainerStyles(
      liteBorder,
      borderWidth,
      forceGradient,
      borderWidthWhenActive,
      active
    ),
  });

interface Props extends BoxProps {
  showGradient?: boolean;
  liteBorder?: boolean;
  borderWidth?: string;
  forceGradient?: boolean;
  borderWidthWhenActive?: string;
  active?: boolean;
}

export const GradientBorderedBox = ({
  showGradient = true,
  forceGradient = false,
  sx,
  liteBorder = false,
  borderWidth = "1px",
  borderWidthWhenActive = "2px",
  active = false,
  ...props
}: Props) => {
  const styles = useStyles(
    liteBorder,
    borderWidth,
    forceGradient,
    borderWidthWhenActive,
    active
  );
  return (
    <Box
      {...props}
      sx={[
        styles.container,
        showGradient || forceGradient ? styles.gradientContainer : null,
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    />
  );
};
